var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.46 3.15a.7.7 0 0 0-.406.329.65.65 0 0 0-.044.271q0 .18.044.271.046.088 1.74 1.783L8.488 7.5 6.793 9.196q-1.692 1.695-1.74 1.787a.6.6 0 0 0-.043.252q0 .165.036.257a.7.7 0 0 0 .143.194q.107.102.194.143a.7.7 0 0 0 .257.036q.165 0 .26-.051.099-.055 2.04-1.996 1.944-1.944 1.995-2.04A.6.6 0 0 0 9.99 7.5a.6.6 0 0 0-.047-.267Q9.898 7.14 7.95 5.189L6.405 3.66q-.36-.36-.494-.447a.36.36 0 0 0-.213-.077h-.044q-.15 0-.194.014"
  })));
};
export default SvgArrowRight;